import React, {memo, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocalizer} from '@/common/services/localizer';
import {fetchRecentLocationsAction} from '@/app/store/locationsHistory/actions';
import {selectRecentLocations} from '@/app/store/locationsHistory/selectors';
import {LocationLink} from '@/app/components/common/LocationLink';
import styles from './RecentLocations.css';

const countLimit = 6;

export const RecentLocations = memo(() => {
	const t = useLocalizer();
	const dispatch = useDispatch();
	const language = t.language;

	const locations = useSelector(selectRecentLocations);

	useEffect(() => {
		dispatch(fetchRecentLocationsAction({language, limit: countLimit}));
	}, [language]);

	return (
		<div className={styles.root}>
			{locations.map(location => (
				<LocationLink key={location.id} className={styles.item} location={location}>
					{location.title}
				</LocationLink>
			))}
		</div>
	);
});

RecentLocations.displayName = 'RecentLocations';
